import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker, Polygon} from 'google-maps-react';


/*Number.prototype.toRad = function() {
   return this * Math.PI / 180;
}

Number.prototype.toDeg = function() {
   return this * 180 / Math.PI;
}*/

class getOnlyviewUbication extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
       lista_poligonos:[],
       openInfoWindowMarkerId: '',
       markers: [
         {
           name: "Current position",
           position: {
             lat: this.props.lat,
             lng: this.props.lon
           }
         }
       ],
       mounted : false,
       mapStyles: [
     {
     "featureType": "administrative.neighborhood",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.man_made",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.landcover",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.terrain",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.attraction",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.business",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.government",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.medical",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.park",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.place_of_worship",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.school",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.sports_complex",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "road.highway",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "road.local",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "transit.station",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "water",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     }
     ]
     };
  }
  /*


  */
  handleToggleOpen = (markerId) => {
      this.setState({
          openInfoWindowMarkerId: markerId
      });
  }

  destinationPoint = ( brng_, dist_ , lat1_, lon1_)=>{
    let brng = brng_
    let dist = dist_
    let lat1 = lat1_
    let lon1 = lon1_
    dist = dist / 6371;
    brng = brng.toRad();

    lat1 = lat1.toRad()
    lon1 = lon1.toRad()

    var lat2 = Math.asin(Math.sin(lat1) * Math.cos(dist) +
                         Math.cos(lat1) * Math.sin(dist) * Math.cos(brng));

    var lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(dist) *
                                 Math.cos(lat1),
                                 Math.cos(dist) - Math.sin(lat1) *
                                 Math.sin(lat2));
    return {lat: lat2.toDeg(),lng:lon2.toDeg()}
  }

  render() {
    let lista_poligonos =[]
    let triangleCoords = []
    const distancia = this.props.distancia
    if(Number(distancia)>0){
      for (var i = 0; i < 71; i++) {
        triangleCoords=[...triangleCoords,this.destinationPoint(i*5,Number(distancia),Number(this.props.lat),Number(this.props.lon))]
      }
    }else{
      if(this.props.polygonos){
        let polygonos = this.props.polygonos
        if(polygonos.length>0){
          polygonos.forEach(poligono => {
            var res = poligono.poligono.split("),(");
            var res_F = poligono.centro.split(" ");
            res.forEach(poligono_total => {
              var poligono_unitario = poligono_total.split(",");
              let triangleCoords_tmp = []
              poligono_unitario.forEach(coordenadas => {
                var data = coordenadas.split(" ");
                triangleCoords_tmp=[...triangleCoords_tmp,{lat: Number(data[0]),lng:Number(data[1])}]
              })
//
              lista_poligonos=[...lista_poligonos,{precio:poligono.precio,etiqueta:poligono.etiqueta,coordenadas:triangleCoords_tmp,centro_lat:Number(res_F[0]),centro_lon:Number(res_F[1])}]
            })
          })
        }
      }

    }
    //console.log(triangleCoords)
    return (
      <React.Fragment>
          <Map
          className="pruebas"
          containerStyle={{
            position: 'relative',
            width: '100%',
            height: '100%'
          }}
          google={this.props.google}
          style={{
            position: 'relative',
            width:'100%',
            height:'100%'
          }}
          zoom={(this.props.zoom)?this.props.zoom:18}
          ref={this.mapRef}
          initialCenter={{ lat: this.props.lat, lng: this.props.lon }}
          disableDefaultUI ={true}
          styles={this.state.mapStyles}
          gestureHandling= {(this.props.edit)?'':'none'}
          zoomControl={(this.props.edit)?true:false}
          >
          {this.state.markers.map((marker, index) => (
              <Marker
                position={marker.position}
                draggable={false}
                name={marker.name}
                key={index}
              />
          ))}

          {(Number(distancia)>0)?
            <Polygon
            paths={triangleCoords}
            strokeColor="#0000FF"
            strokeOpacity={0.8}
            strokeWeight={2}
            fillColor="#0000FF"
            fillOpacity={0.35} />
            :
            (lista_poligonos)?
             (lista_poligonos.length>0)?
                lista_poligonos.map((marker, index) => (
                    <Polygon key={index}
                    paths={marker.coordenadas}
                    strokeColor="#0000FF"
                    strokeOpacity={0.8}
                    strokeWeight={2}
                    fillColor="#0000FF"
                    fillOpacity={0.35} />
                ))
             :''
             :''
          }

          {(lista_poligonos)?
               (lista_poligonos.length>0)?
                 lista_poligonos.map((marker, index) => (
                   <Marker
                     position={{lat:marker.centro_lat,lng:marker.centro_lon}}
                     draggable={false}
                     name={"marker.name"}
                     key={index}
                     label={marker.etiqueta+" ("+marker.precio+" $)"}
                     onClick={() => this.handleToggleOpen(i)}
                   />
                 ))
               :''
               :''
          }
          </Map>
        </React.Fragment>
    )
  }
//AIzaSyAhGBIYFLkWPbqHVQ_kHj3nWwrkDiiFUXg
}
export default GoogleApiWrapper({
  apiKey: 'AIzaSyAhGBIYFLkWPbqHVQ_kHj3nWwrkDiiFUXg'
})(getOnlyviewUbication);
